import { __rest } from "tslib";
import React from 'react';
import { Button, Modal } from 'antd';
import classnames from 'classnames';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import styles from './alert.module.scss';
import { AlertCloseIcon, AlertErrorIcon, InfoIcon, WarnIcon } from '../Icons/icons';
import { getBodyFixHeight } from '@web-common/utils/constant';
import { WmKfEntry } from '@web-common/components/WmKfEntry';
import { getIn18Text } from 'api';
class Alert {
    constructor() {
        this.modal = Modal;
    }
    destroyAll() {
        this.modal.destroyAll();
    }
    info(e) {
        return this.modal.info(Alert.mergeProps(e, {
            icon: React.createElement(InfoIcon, { style: { marginRight: '6px' } }),
        }));
    }
    error(e) {
        return this.modal.error(Alert.mergeProps(e, {
            icon: React.createElement(AlertErrorIcon, null),
        }));
    }
    confirm(e) {
        return this.modal.confirm(Alert.mergeProps(e, {
            icon: React.createElement(AlertErrorIcon, null),
        }));
    }
    debug(e) {
        return this.warn(e);
    }
    warn(e) {
        return this.modal.warning(Alert.mergeProps(e, {
            icon: React.createElement(WarnIcon, null),
        }));
    }
    static mergeProps(userProps, innerProps) {
        const baseProps = Alert.getCustomProps();
        const mergedProps = Object.assign(Object.assign(Object.assign({}, baseProps), innerProps), userProps);
        if (userProps.edmJump) {
            mergedProps.content = (React.createElement("div", { className: styles.colort3 },
                React.createElement("div", null,
                    "\u7CFB\u7EDF\u68C0\u6D4B\u5230\u90AE\u4EF6\u4E2D\u53EF\u80FD\u5305\u542B\u63A8\u5E7F/\u8425\u9500\u6027\u8D28\u5185\u5BB9\uFF0C\u5DF2\u7EC8\u6B62\u90AE\u4EF6\u53D1\u9001\u3002\u5982\u60A8\u8BA4\u4E3A\u5B58\u5728\u8BEF\u5224\uFF0C\u8BF7\u70B9\u51FB",
                    React.createElement(WmKfEntry, { style: { display: 'inline-block' } },
                        React.createElement("span", { className: styles.buzzkf }, "\u00A0\u5728\u7EBF\u5BA2\u670D\u00A0")),
                    "\u8054\u7CFB\u4EBA\u5DE5\u670D\u52A1\u53CD\u9988\u3002"),
                React.createElement("br", null),
                React.createElement("div", null,
                    "\u53D1\u4FE1\u6548\u679C\u5C0F\u8D34\u58EB\uFF1A",
                    React.createElement("br", null),
                    "\u60A8\u5DF2\u8D2D\u4E70\u8425\u9500\u4E13\u7528\u901A\u9053\u3010\u5916\u8D38\u901A-\u5BA2\u6237\u5F00\u53D1\u3011\uFF0C\u4F7F\u7528\u8BE5\u529F\u80FD\u53D1\u4FE1\u6548\u679C\u6709\u4FDD\u969C\u3002 \u4F7F\u7528\u5F53\u524D\u901A\u9053\u3010\u90AE\u4EF6\u3011\u53D1\u9001\u63A8\u5E7F/\u8425\u9500\u6027\u8D28\u90AE\u4EF6\uFF0C\u5BB9\u6613\u5BFC\u81F4\u57DF\u540D\u88AB\u62C9\u9ED1\u7B49\u60C5\u51B5\u51FA\u73B0\uFF0C\u5F71\u54CD\u6B63\u5E38\u90AE\u4EF6\u7684\u53D1\u9001\u3002")));
            if (!userProps.hasEdmPermission) {
                mergedProps.okText = (React.createElement(WmKfEntry, null,
                    React.createElement("span", null, "\u8054\u7CFB\u5BA2\u670D")));
                mergedProps.content = (React.createElement("div", { className: styles.colort3 },
                    React.createElement("div", null,
                        "\u7CFB\u7EDF\u68C0\u6D4B\u5230\u90AE\u4EF6\u4E2D\u53EF\u80FD\u5305\u542B\u63A8\u5E7F/\u8425\u9500\u6027\u8D28\u5185\u5BB9\uFF0C\u5DF2\u7EC8\u6B62\u90AE\u4EF6\u53D1\u9001\u3002\u5982\u60A8\u8BA4\u4E3A\u5B58\u5728\u8BEF\u5224\uFF0C\u8BF7\u70B9\u51FB",
                        React.createElement(WmKfEntry, { style: { display: 'inline-block' } },
                            React.createElement("span", { className: styles.buzzkf, onClick: () => {
                                    Modal.destroyAll();
                                } }, "\u00A0\u5728\u7EBF\u5BA2\u670D\u00A0")),
                        "\u8054\u7CFB\u4EBA\u5DE5\u670D\u52A1\u53CD\u9988\u3002"),
                    React.createElement("br", null),
                    React.createElement("div", null,
                        "\u53D1\u4FE1\u6548\u679C\u5C0F\u8D34\u58EB\uFF1A",
                        React.createElement("br", null),
                        "\u4F7F\u7528\u5F53\u524D\u901A\u9053\u3010\u90AE\u4EF6\u3011\u53D1\u9001\u63A8\u5E7F/\u8425\u9500\u6027\u8D28\u90AE\u4EF6\uFF0C\u5BB9\u6613\u5BFC\u81F4\u57DF\u540D\u88AB\u62C9\u9ED1\u7B49\u60C5\u51B5\u51FA\u73B0\uFF0C\u5F71\u54CD\u6B63\u5E38\u90AE\u4EF6\u7684\u53D1\u9001\u3002 \u63A8\u8350\u60A8\u4F7F\u7528\u8425\u9500\u4E13\u7528\u901A\u9053\u3010\u5916\u8D38\u901A-\u5BA2\u6237\u5F00\u53D1\u3011\uFF0C\u4F7F\u7528\u8BE5\u529F\u80FD\u53D1\u4FE1\u6548\u679C\u6709\u4FDD\u969C\uFF0C\u70B9\u51FB",
                        React.createElement(WmKfEntry, { style: { display: 'inline-block' } },
                            React.createElement("span", { className: styles.buzzkf, onClick: () => {
                                    Modal.destroyAll();
                                } }, "\u00A0\u8054\u7CFB\u5BA2\u670D\u00A0")),
                        "\u4E86\u89E3\u66F4\u591A\u3002")));
            }
        }
        if (userProps.funcBtns) {
            mergedProps.content = (React.createElement(React.Fragment, null,
                userProps.content,
                Alert.renderFooter(userProps.funcBtns, userProps.nmrText)));
        }
        mergedProps.className = classnames(mergedProps.className, {
            [styles.alertCustomBtns]: userProps.funcBtns,
            [styles.alertFooterBorder]: userProps.footerTopBorder,
            [styles.alertCustomContent]: mergedProps.icon === null,
            [styles.alertNoContent]: mergedProps.content === undefined,
        });
        return mergedProps;
    }
    static renderFooter(funcBtns, nmrText = getIn18Text('BUZAITIXING')) {
        let nrmValue = false;
        const isNmrAlert = funcBtns.find(b => b.nmr !== undefined) !== undefined;
        return (React.createElement("div", { className: styles.btns },
            isNmrAlert && (React.createElement(Checkbox, { className: styles.btnLeft, onChange: e => {
                    nrmValue = e.target.checked;
                } }, nmrText)),
            funcBtns.map(b => {
                const { text, btnProps, pullLeft, nmr, onClick } = b, rest = __rest(b, ["text", "btnProps", "pullLeft", "nmr", "onClick"]);
                let handleClick = onClick;
                if (nmr && isNmrAlert && onClick) {
                    handleClick = e => {
                        onClick(e, nrmValue);
                    };
                }
                const appendProps = Object.assign(Object.assign(Object.assign({}, rest), btnProps), { className: classnames(btnProps === null || btnProps === void 0 ? void 0 : btnProps.className, {
                        [styles.btnLeft]: pullLeft,
                    }) });
                return (React.createElement(Button, Object.assign({ key: b.text, type: b.type, onClick: handleClick }, appendProps), text));
            })));
    }
    static getCustomProps() {
        const props = {
            className: styles.alert,
            width: 448,
            okText: getIn18Text('QUEDING'),
            cancelText: getIn18Text('QUXIAO'),
            zIndex: 1100,
            maskStyle: {
                top: getBodyFixHeight(),
            },
            transitionName: '',
            maskTransitionName: '',
            closable: false,
            closeIcon: React.createElement(AlertCloseIcon, null),
        };
        return props;
    }
}
export default new Alert();
